import { useNavigate } from "react-router-dom";

// Hook centralizujący logikę nawigacji
export const useNavigationHelper = () => {
  const navigate = useNavigate();

  const goToMainRoot = () => {
    navigate(`/`);
  };

  // Szczegóły zgłoszenia
  const goToApplicationDetails = (contestId: string, applicationId: string) => {
    navigate(`/contests/${contestId}/applications/${applicationId}/details`);
  };

  // Szczegóły opłat na zgłoszeniu
  const goToApplicationPaymentsDetails = (contestId: string, applicationId: string) => {
    navigate(`/contests/${contestId}/applications/${applicationId}/paymentsDetails`);
  };

  // Szczegóły zawodów turnieju
  const goToContestDetails = (contestId: string) => {
    navigate(`/contests/${contestId}/details`);
  };

  // Lista zawodów / turniejów
  const goToContestsList = () => {
    navigate(`/contests`);
  };

  // Nowa prezentacja
  const goToNewPresentation = (
    contestId: string,
    applicationId: string,
    categoryId: string,
    state?: any,
  ) => {
    navigate(
      `/contests/${contestId}/applications/${applicationId}/categories/${categoryId}/presentations/new`,
      { state },
    );
  };

  // Edycja prezentacji
  const goToPresentationEdit = (
    contestId: string,
    applicationId: string,
    categoryId: string,
    presentationId: string,
    state?: any,
  ) => {
    navigate(
      `/contests/${contestId}/applications/${applicationId}/categories/${categoryId}/presentations/${presentationId}`,
      { state },
    );
  };

  // Powrót do szczegółów zgłoszenia z zachowaniem state (używane w formularzach)
  const goBackToApplicationDetails = (contestId: string, applicationId: string, state?: any) => {
    navigate(`/contests/${contestId}/applications/${applicationId}/details`, {
      state,
      replace: true,
    });
  };

  // Ustawienia konta
  const goToAccountSettings = () => {
    navigate(`/account/settings`);
  };

  // Strona podziękowania po rejestracji
  const goToThankYouPage = () => {
    navigate(`/thank-you`);
  };

  return {
    goToApplicationDetails,
    goToApplicationPaymentsDetails,
    goToContestDetails,
    goToContestsList,
    goToMainRoot,
    goToNewPresentation,
    goToAccountSettings,
    goToPresentationEdit,
    goToThankYouPage,
    goBackToApplicationDetails,
  };
};
